// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"61f7428b","209":"2f4ae801","829":"17ad8c04","878":"f6da1607"}[chunkId] + ".chunk.js";
};